import testConfig from './system.test.config'
import devConfig from './system.dev.config'
import prodConfig from './system.prod.config'
let config;
switch (process.env.VUE_APP_NODE_ENV) {
  case 'test': //测试环境
    config = testConfig
    break;
  case 'dev': //开发环境
    config = devConfig
    break;
  case 'prod': //生产环境
    config = prodConfig
    break;
  default:
    config = devConfig
    break;
}
export default config